module.exports = __webpack_public_path__ + "static/media/beta-3.2478b4b7.svg";